import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralize } from "@common/helpers/string";

interface RulesFilterLabelProps {
    filters: Pick<FiltersTypes, "transactionRulesIds">;
}

export const RulesFilterLabel: React.FC<RulesFilterLabelProps> = ({
    filters: { transactionRulesIds },
}) => (
    <>
        {transactionRulesIds?.length}{" "}
        {pluralize("Rule", transactionRulesIds?.length ?? 0)}
    </>
);
